<template>
  <!--    <div class="guide">-->
  <!--        <div class="overlay" @click="closeMe"></div>-->
  <!--        <div class="guide-body">-->
  <b-sidebar
    :id="`sidebar_guide_${id}`"
    v-model="visible"
    class="guide-body"
    right
    no-header-close
    z-index="10"
    backdrop
  >
    <div class="dark-sec"></div>
    <div class="content">
      <div class="title">
        <h5>Guide Details</h5>
        <div @click="closeMe">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.2929 6.29289C11.9024 6.68342 11.9024 7.31658 12.2929 7.70711L16.5858 12L12.2929 16.2929C11.9024 16.6834 11.9024 17.3166 12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071L18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929L13.7071 6.29289C13.3166 5.90237 12.6834 5.90237 12.2929 6.29289Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 6.29289C4.90237 6.68342 4.90237 7.31658 5.29289 7.70711L9.58579 12L5.29289 16.2929C4.90237 16.6834 4.90237 17.3166 5.29289 17.7071C5.68342 18.0976 6.31658 18.0976 6.70711 17.7071L11.7071 12.7071C12.0976 12.3166 12.0976 11.6834 11.7071 11.2929L6.70711 6.29289C6.31658 5.90237 5.68342 5.90237 5.29289 6.29289Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <div class="user">
        <div class="user-profile">
          <img v-if="user.imgURL" :src="user.imgURL" alt="" />
          <empty-avatar
            v-else
            :firstname="user.lastname"
            :lastname="user.lastname"
          />
          <div class="user-info">
            <h6>Guide Name</h6>
            <h3>{{ user.firstname }}</h3>
          </div>
        </div>
        <p class="bio">
          {{ guides.profile ? guides.profile.bio : "" }}
        </p>
        <div class="foot">
          <div class="address">
            <h6>
              {{
                guides.profile
                  ? guides.profile.social
                    ? guides.profile.social.businessURL
                    : ""
                  : ""
              }}
            </h6>
          </div>
          <!-- <button class="book-session">
            Book a session
          </button> -->
        </div>
        <b-button
          v-if="guides.profile && guides.profile.videoURL"
          class="video-btn"
          @click="$bvModal.show(guideHelpVideo)"
          >Watch Video</b-button
        >
        <br /><br />
      </div>
      <!--            </div>-->
      <div class="fff-sec">
        <div class="guide-sec">
          <div
            class="guide-blog"
            v-for="(cond, index) in setGuideDetail"
            :key="index"
          >
            <h2 class="title">{{ cond.title }}</h2>

            <div class="action-blog">
              <!-- <button class="btn-fill" v-b-modal="`charity-modal_${index}`">
                Charity
              </button> -->
              <!-- <b-modal
                :id="`charity-modal_${index}`"
                :title="`Charity ${user.firstname}`"
              >
                <donateButton :index="index"></donateButton>
              </b-modal> -->
              <span class="charity" v-if="cond.charity">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.9">
                    <path
                      d="M5.92944 5.11759C5.92945 7.96936 9.74295 11.4802 11.9932 12.9116C14.4128 11.3528 18.0271 8.6764 18.0271 5.44116C18.0271 3.90472 17.131 2 15.279 2C13.7974 2 12.6205 2.64709 11.9932 3.8235C11.3361 2.61768 9.60355 2 8.76717 2C7.93079 2 5.92944 2 5.92944 5.11759Z"
                      stroke="#52595E"
                    />
                    <path
                      d="M7.72155 17.8233C7.67176 17.5586 7.15401 16.6763 7.15401 16.6763L5.45137 15.0587C5.45137 15.0587 4.55525 14.1175 4.01758 13.4999C3.4799 12.8822 3.43016 12.3234 3.56956 11.9705C3.65425 11.7561 3.95788 11.5881 4.07736 11.5881M4.07736 11.5881C4.22672 11.5587 4.61504 11.6176 4.85396 11.8528C5.12284 12.1175 6.40724 13.3822 7.15401 14.1175C7.90078 14.8528 10.2905 15.8233 10.7087 16.8527C11.1269 17.8821 10.8282 20.3821 10.8282 22.0879L6.67608 22.1174C6.80552 21.6468 6.67608 20.6762 6.67608 19.8233C6.67608 18.5021 5.15271 17.3822 4.67478 17.0292C4.19686 16.6763 2.16558 15.0587 2.16558 14.1175C2.16557 12.2902 1.89441 8.76157 2.04612 7.52938C2.16561 6.55881 2.28506 6.02939 2.82274 6.23527C3.36041 6.44115 3.59938 6.87057 3.59938 7.64703C3.59938 8.42349 3.93797 10.6 4.07736 11.5881Z"
                      stroke="#52595E"
                    />
                    <path
                      d="M16.2784 17.8233C16.3282 17.5586 16.846 16.6763 16.846 16.6763L18.5486 15.0587C18.5486 15.0587 19.4447 14.1175 19.9824 13.4999C20.5201 12.8822 20.5698 12.3234 20.4304 11.9705C20.3458 11.7561 20.0421 11.5881 19.9226 11.5881M19.9226 11.5881C19.7733 11.5587 19.385 11.6176 19.146 11.8528C18.8772 12.1175 17.5928 13.3822 16.846 14.1175C16.0992 14.8528 13.7095 15.8233 13.2913 16.8527C12.8731 17.8821 13.1718 20.3821 13.1718 22.0879L17.3239 22.1174C17.1945 21.6468 17.3239 20.6762 17.3239 19.8233C17.3239 18.5021 18.8473 17.3822 19.3252 17.0292C19.8031 16.6763 21.8344 15.0587 21.8344 14.1175C21.8344 12.2902 22.1056 8.76157 21.9539 7.52938C21.8344 6.55881 21.7149 6.02939 21.1773 6.23527C20.6396 6.44115 20.4006 6.87057 20.4006 7.64703C20.4006 8.42349 20.062 10.6 19.9226 11.5881Z"
                      stroke="#52595E"
                    />
                  </g>
                </svg>
              </span>
              <h4 class="price">
                <span>${{ cond.price }}</span> /{{
                  `${cond.duration} minutes` || "session"
                }}
              </h4>

              <!-- <button class="btn-fill" v-b-modal="`book_${index}`">Book</button> -->
              <button @click="$emit('show-booking', cond)" class="btn-fill">
                Book
              </button>
            </div>
            <p class="description" v-if="cond.summary">
              {{ cond.summary.substr(0, cond.read) }}
              <span
                v-if="cond.read == 300"
                @click="cond.read = cond.summary.length"
                >Read More</span
              >
              <span v-else @click="cond.read = 300">Read less</span>
            </p>
            <p class="description" v-else>
              No description
            </p>
            <b-button
              v-if="cond.videoURL"
              class="video-btn"
              @click="$bvModal.show(planVideo)"
              >Watch Video</b-button
            >
            <vimeo-modal
              v-if="cond.videoURL"
              :id="planVideo"
              :url="cond.videoURL"
            ></vimeo-modal>
            <!-- <transition name="slide-fade">
              <cardPlan
                :modal_id="`book_${index}`"
                :plan="cond"
                :user-profile="user"
                :guide="user"
                :key="index"
              />
            </transition> -->
          </div>
        </div>
      </div>
    </div>
    <vimeo-modal
      v-if="guides.profile && guides.profile.videoURL"
      :id="guideHelpVideo"
      :url="guides.profile.videoURL"
    ></vimeo-modal>
    <!--        </div>-->
  </b-sidebar>
  <!--    </div>-->
</template>

<script>
import { mapGetters } from "vuex";
import emptyAvatar from "@/components/jab/emptyAvatar";
import vimeoModal from "@/components/common/vimeoModal";
export default {
  name: "Guide",
  components: {
    emptyAvatar,
    vimeoModal
  },
  props: {
    guides: {
      required: true
    },
    idCollapses: {
      type: String
    },
    onVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      id: null,
      visible: false,
      userInfo: {},
      processed: false,
      guideDetails: {},
      guideHelpVideo: "guide-help-video",
      planVideo: "plan-video"
    };
  },
  watch: {
    idCollapses(n, o) {
      this.id = n;
      console.log("this.guides.user", this.guides);
      this.user = this.guides.user;

      const profile = this.guides.profile || this.guides.profile_update;

      this.setGuideDetail = profile !== undefined ? profile.plans : [];
    },
    onVisible(n, o) {
      this.visible = !this.visible;
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    setGuideDetail: {
      get() {
        return this.guideDetails;
      },
      set(data) {
        this.guideDetails = data;
      }
    },
    user: {
      get() {
        return this.userInfo;
      },
      set(user) {
        this.userInfo = user;
      }
    }
  },
  methods: {
    closeMe() {
      console.log("close");
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
/*.guide{*/
/*    position: fixed;*/
/*    left: 0;*/
/*    top: 0;*/
/*    right: 0;*/
/*    bottom: 0;*/
/*    !*background-color: red;*!*/
/*    z-index: 9;*/
/*    overflow-y: scroll;*/
/*    display: grid;*/
/*    grid-template-columns: 1fr 335px;*/
/*    scrollbar-width: none; !* Firefox *!*/
/*    -ms-overflow-style: none;  !* Internet Explorer 10+ *!*/
/*    &::-webkit-scrollbar { !* WebKit *!*/
/*        width: 0;*/
/*        height: 0;*/
/*    }*/
.overlay {
  background-color: transparent;
  z-index: 10;
}
.dark-sec {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 272px;
  background-color: #474d52;
  z-index: -1;
}
.guide-body {
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #474d52;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  z-index: 99;
  background-color: #fff;
  position: relative;
  .content {
    position: relative;
    padding: 15px;
    padding-top: 0;
    * {
      z-index: 99 !important;
    }
  }
  /*.dark-sec{*/
  /*    background: #474D52;*/

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h5 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: white;
    }
    div {
      cursor: pointer;
    }
  }
  .user {
    .user-profile {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 82px;
        height: 82px;
        border-radius: 8px;
        object-fit: cover;
      }
      .user-info {
        margin-left: 20px;
        h6 {
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 10px;
          line-height: 14px;
          color: white;
          opacity: 0.7;
          margin: 0;
        }
        h3 {
          font-family: "Nunito", sans-serif;
          font-weight: 600;
          font-size: 18px;
          line-height: 25px;
          color: #ffffff;
          margin: 10px 0;
        }
        h5 {
          font-family: "Nunito", sans-serif;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          display: flex;
          align-items: center;

          /* White */

          color: #ffffff;
          span {
            margin-right: 7px;
          }
        }
      }
    }
    .bio {
      font-family: "Nunito", sans-serif;
      font-weight: normal;
      font-size: 10px;
      line-height: 14px;
      margin: 14px 0;
      /* White */

      color: #ffffff;
    }
    .foot {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .address {
        h6 {
          font-family: "Nunito", sans-serif;
          font-weight: normal;
          font-size: 10px;
          line-height: 14px;
          color: #fff;
        }
      }
      .book-session {
        font-family: "Nunito", sans-serif;
        background: #6aa84f;
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
        border-radius: 100px;
        padding: 4px 15px;
        border: none;
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        width: 115px;
        height: 26px;
      }
    }
    .video-btn {
      font-size: 12px;
      border-radius: 25px;
      background: none;
      color: #fff;
      border-color: #fff;
      padding: 3px;
      outline: none;
    }
  }
  /*}*/

  .guide-sec {
    padding: 15px 0;
    margin-top: -35px;
    .guide-blog {
      box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 15px;
      margin: 10px 0;
      background-color: #fff;
      .title {
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
      }
      .action-blog {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .charity {
          margin-right: -45px;
        }
        h4 {
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          line-height: 19px;
          color: #474d52;
          margin: 0;
          span {
            font-size: 16px;
            font-weight: bold;
            color: #557efb;
          }
        }
        .btn-fill {
          font-family: "Nunito", sans-serif;
          width: 62px;
          height: 24px;
          font-weight: 600;
          font-size: 12px;
          line-height: 16px;
          padding: 0;
          border-radius: 20px;
        }
      }
      .description {
        margin-top: 15px;
        font-family: "Nunito", sans-serif;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;

        /* Body */

        color: #474d52;
        span {
          color: #557efb;
          text-decoration: underline;
          cursor: pointer;
          font-weight: 600;
        }
      }
      .video-btn {
        font-size: 12px;
        border-radius: 25px;
        background: none;
        color: black;
        border-color: #000;
        padding: 3px;
        outline: none;
      }
    }
  }
}
/*}*/
button:hover,
a:hover {
  box-shadow: 0px 2px 6px 0px #cbcbcb;
  cursor: pointer;
}
.guide-body {
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #222;
  }
}
</style>
